export var ConsequenceType;
(function (ConsequenceType) {
    ConsequenceType["Customer"] = "customer";
    ConsequenceType["Financial"] = "financial";
    ConsequenceType["LegalAndRegulatory"] = "legal_and_regulatory";
    ConsequenceType["Operational"] = "operational";
    ConsequenceType["Reputational"] = "reputational";
})(ConsequenceType || (ConsequenceType = {}));
//# sourceMappingURL=consequence-type.js.map